import Vue from 'vue';
import { extend, localize, setInteractionMode } from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru.json';

import {
    isUniqueUserEmail,
    isUniqueOrganisationPhone,
    isUniqueOrganisationINN,
    filesCount,
    confirmed,
    length,
    max,
    min,
    regex,
    required,
    email,
    double,
    digits,
} from './VeeValidateRules';
import { customEager } from './VeeValidateModes';

extend('min', min);
extend('max', max);
extend('regex', regex);
extend('required', required);
extend('confirmed', confirmed);
extend('filesCount', filesCount);
extend('email', email);
extend('double', double);
extend('digits', digits);
extend('length', length);
extend('isUniqueOrganisationINN', isUniqueOrganisationINN);
extend('isUniqueOrganisationPhone', isUniqueOrganisationPhone);
extend('isUniqueUserEmail', isUniqueUserEmail);

localize({
    ru: {
        messages: ru.messages,
        names: {
            username: 'Логин',
            password: 'Пароль',
            oldPassword: 'Старый пароль',
            repeatPassword: 'Повторить пароль',
        },
    },
});

let LOCALE = 'ru';

Object.defineProperty(Vue.prototype, 'locale', {
    get() {
        return LOCALE;
    },

    set(locale: string) {
        LOCALE = locale;

        localize(locale);
    },
});

localize(LOCALE);

setInteractionMode('customEager', customEager);
